export const MATTER_COLOR_DARK = '#000000';
export const MATTER_COLOR = '#4a4a4a';
export const MATTER_COLOR_ANTI = '#b2b2b2';
export const MATTER_COLOR_LIGHT = '#ffffff';

export const SUCCESS_COLOR = '#2ecc71';
export const ATTENTION_COLOR = '#ffaa00';
export const FAIL_COLOR = '#ff0000';
